import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLibrary } from '../context/LibraryContext';
import { usePlayer } from '../context/PlayerContext';
import { FaMusic, FaListUl, FaUpload, FaYoutube } from 'react-icons/fa';
import '../styles/Home.css';

const Home = () => {
  const { songs, playlists, loading, error } = useLibrary();
  const { playSong } = usePlayer();
  const [recentSongs, setRecentSongs] = useState([]);
  const [featuredPlaylists, setFeaturedPlaylists] = useState([]);

  useEffect(() => {
    // Get the most recent songs
    if (songs.length > 0) {
      setRecentSongs(songs.slice(0, 5));
    }

    // Get some playlists to feature
    if (playlists.length > 0) {
      setFeaturedPlaylists(playlists.slice(0, 3));
    }
  }, [songs, playlists]);

  const handlePlaySong = (song) => {
    playSong(song, songs, songs.findIndex(s => s._id === song._id));
  };

  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="hero-content">
          <h1>Harmoniq</h1>
          <p>Votre application musicale intelligente</p>
          <div className="hero-buttons">
            <Link to="/library" className="btn btn-primary">
              Explorer ma bibliothèque
            </Link>
            <Link to="/upload" className="btn btn-secondary">
              Importer de la musique
            </Link>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2>Fonctionnalités</h2>
        <div className="features-grid">
          <div className="feature-card">
            <FaMusic className="feature-icon" />
            <h3>Analyse Audio</h3>
            <p>Détection automatique du tempo, de la tonalité et du genre musical</p>
          </div>
          <div className="feature-card">
            <FaListUl className="feature-icon" />
            <p>Créez des playlists intelligentes basées sur le tempo, la tonalité ou l'ambiance</p>
          </div>
          <div className="feature-card">
            <FaUpload className="feature-icon" />
            <h3>Import Facile</h3>
            <p>Importez vos fichiers MP3 et WAV en quelques clics</p>
          </div>
          <div className="feature-card">
            <FaYoutube className="feature-icon" />
            <h3>Intégration YouTube</h3>
            <p>Ajoutez de la musique directement depuis YouTube</p>
          </div>
        </div>
      </section>

      {recentSongs.length > 0 && (
        <section className="recent-section">
          <div className="section-header">
            <h2>Ajouts récents</h2>
            <Link to="/library" className="view-all">Voir tout</Link>
          </div>
          <div className="songs-grid">
            {recentSongs.map(song => (
              <div key={song._id} className="song-card" onClick={() => handlePlaySong(song)}>
                <div className="song-card-cover">
                  <div className="song-card-play">
                    <FaMusic />
                  </div>
                </div>
                <div className="song-card-info">
                  <h3 className="song-card-title">{song.title}</h3>
                  <p className="song-card-artist">{song.artist}</p>
                  <div className="song-card-meta">
                    <span>{song.bpm} BPM</span>
                    <span>{song.key}</span>
                    <span>{song.genre}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {featuredPlaylists.length > 0 && (
        <section className="playlists-section">
          <div className="section-header">
            <h2>Playlists</h2>
            <Link to="/playlists" className="view-all">Voir tout</Link>
          </div>
          <div className="playlists-grid">
            {featuredPlaylists.map(playlist => (
              <Link to={`/playlists/${playlist._id}`} key={playlist._id} className="playlist-card">
                <div className="playlist-card-cover">
                  <div className="playlist-card-count">
                    {playlist.songs.length} morceaux
                  </div>
                </div>
                <div className="playlist-card-info">
                  <h3 className="playlist-card-title">{playlist.name}</h3>
                  <p className="playlist-card-desc">{playlist.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}

      {loading && <div className="loading">Chargement...</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Home;
